import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=6d2fa37b&"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js&"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports